import { queryOptions, useQuery } from '@tanstack/react-query';
import { getParkedDeposits } from '@/services/api/parked-deposits';

export const PARKED_DEPOSITS_QUERY_KEY = ['funds', 'parked-deposits'] as const;

export const parkedDepositsQueryOptions = () =>
  queryOptions({
    queryKey: PARKED_DEPOSITS_QUERY_KEY,
    queryFn: getParkedDeposits,
  });

export const useParkedDeposits = () => useQuery(parkedDepositsQueryOptions());
